import type { MdaiCardProps } from "../../../components/MdaiCard";

interface MapCardsWithIconsParams {
  cards?: Pick<MdaiCardProps, "title" | "body">[];
  icons: readonly NonNullable<MdaiCardProps["Icon"]>[];
  fallbackIcon: NonNullable<MdaiCardProps["Icon"]>;
}

export function mapCardsWithIcons({
  cards,
  icons,
  fallbackIcon,
}: MapCardsWithIconsParams): MdaiCardProps[] {
  return (cards ?? []).map((card, index) => ({
    Icon: icons[index] ?? fallbackIcon,
    title: card.title,
    body: card.body,
  }));
}
